import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/domain-validation.svg'


const _hoisted_1 = { class: "container py-3" }
const _hoisted_2 = { class: "breadcrumb-voucher py-3" }
const _hoisted_3 = { "aria-label": "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb-item" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "row pt-5" }
const _hoisted_9 = { class: "col-12 col-lg-7 d-flex flex-column justify-content-start" }
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = { class: "my-5 d-flex justify-content-end" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  id: "modal-email-validation-button",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal-email-validation"
}
const _hoisted_14 = {
  id: "modal-only-desktop-issuer-button",
  "data-bs-target": "#modal-only-desktop",
  "data-bs-toggle": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Wizzard = _resolveComponent("Wizzard")!
  const _component_Selectable = _resolveComponent("Selectable")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_ModalEmailValidation = _resolveComponent("ModalEmailValidation")!
  const _component_ModalOnlyUseOnDesktop = _resolveComponent("ModalOnlyUseOnDesktop")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("ol", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    class: "color--info",
                    name: "house"
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                class: "color--info",
                to: "/"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Emissão de Certificado ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                class: "color--primary disabled fw-600",
                to: "/"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Certificado SSL ")
                ])),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createVNode(_component_Wizzard, { "current-page": "alldone" }),
      _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "w-100 fw-600 text-start mt-5" }, " Pra terminar, vamos validar seu domínio ", -1)),
      _createElementVNode("div", _hoisted_8, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "d-none d-lg-block col-lg-5 d-flex justify-content-center" }, [
          _createElementVNode("img", {
            id: "domain-validation-image",
            src: _imports_0,
            alt: "domain-validation"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-start fs-6 mb-4" }, " Escolha um tipo de validação para prosseguirmos com a emissão do seu Certificado Digital SSL. ", -1)),
          _createElementVNode("div", _hoisted_10, [
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "w-100 text-start fs-6 mb-2" }, " Escolha um tipo de validação * ", -1)),
            _createVNode(_component_Selectable, {
              modelValue: _ctx.validationMethod,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.validationMethod) = $event)),
              icon: "lock",
              placeholder: "Selecione uma opção",
              options: _ctx.validationMethodOptions
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "w-100 text-start fs-6 mb-2" }, " Escolha o domínio que deseja validar * ", -1)),
            _createVNode(_component_Selectable, {
              modelValue: _ctx.domain,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.domain) = $event)),
              icon: "globe",
              placeholder: "Selecione uma opção",
              options: _ctx.domainOptions,
              "is-disabled": !_ctx.domainsAreLoaded
            }, null, 8, ["modelValue", "options", "is-disabled"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: _normalizeClass([
              'progress-button btn btn-primary',
              // eslint-disable-next-line max-len
              !_ctx.validationMethodIsSelected || !_ctx.domainIsSelected
                ? 'btn-secondary disabled'
                : 'btn-primary',
            ]),
              disabled: !_ctx.validationMethodIsSelected || !_ctx.domainIsSelected,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleNextStep && _ctx.handleNextStep(...args)))
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "me-2" }, "Avançar", -1)),
              _createVNode(_component_Icon, { name: "arrow-right" })
            ], 10, _hoisted_12)
          ])
        ])
      ]),
      _createVNode(_component_Contact),
      _createVNode(_component_ModalEmailValidation, {
        ref: "modalEmailValidation",
        "selected-domain": _ctx.domain,
        error: _ctx.errorCode,
        onValidateEmail: _ctx.handleValidateEmail,
        onRemoveErrorLog: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorCode = ''))
      }, null, 8, ["selected-domain", "error", "onValidateEmail"]),
      _withDirectives(_createElementVNode("button", _hoisted_13, null, 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_ModalOnlyUseOnDesktop, null, {
        message: _withCtx(() => _cache[11] || (_cache[11] = [
          _createElementVNode("h3", null, [
            _createTextVNode(" A validação de seu domínio através de Requisção HTTP, deve ser feita em um "),
            _createElementVNode("strong", null, "computador ou notebook.")
          ], -1)
        ])),
        _: 1
      }),
      _withDirectives(_createElementVNode("button", _hoisted_14, null, 512), [
        [_vShow, false]
      ])
    ]),
    _createVNode(_component_Loading, { "is-loading": _ctx.isLoading }, null, 8, ["is-loading"])
  ], 64))
}